export const COTIZACION_FORM = {
    name: "",
    email: "",
    phone: "",
    serviceType: "",
    address: "",
    message: ""
};